import comp from "./SubjectCategory";
export default comp;
